export default __webpack_public_path__ + "static/media/russell.b4994d1a.jpg";